/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountInfo
 */
export interface AccountInfo {
    /**
     * The account name
     * @type {string}
     * @memberof AccountInfo
     */
    accountName: string;
    /**
     * The account ID
     * @type {number}
     * @memberof AccountInfo
     */
    accountId: number;
}

/**
 * Check if a given object implements the AccountInfo interface.
 */
export function instanceOfAccountInfo(value: object): boolean {
    if (!('accountName' in value)) return false;
    if (!('accountId' in value)) return false;
    return true;
}

export function AccountInfoFromJSON(json: any): AccountInfo {
    return AccountInfoFromJSONTyped(json, false);
}

export function AccountInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'accountName': json['accountName'],
        'accountId': json['accountId'],
    };
}

export function AccountInfoToJSON(value?: AccountInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountName': value['accountName'],
        'accountId': value['accountId'],
    };
}

